/* loaded by smart-asset */
export default require("./42~zlUEqPuV.svg")